import React, { useEffect, useState, useMemo } from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Carrot } from '../../../svg/Carrot.svg';
import t from '@jetshop/intl';
import { Leg3D } from '../Elements/Leg3D';
import { StepHeaderTextDescription } from '../Elements/StepHeaderTextDescription';
import { ProductPrice } from '../Elements/Product/ProductPrice';
import getProduct from '../Data/GetProduct';
import VariantTextileMapConfig from '../Config/variantTextileMap.config';

const StyledWrapperStepFive = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 0 auto 4rem;
  width: 100%;
`
const StepHeader = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  width: 100%;
  position: relative;
  margin: 0 auto 2rem;
  height: 35px;
  max-width: 1280px;
  padding: 0 60px;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }

  @media screen and (max-width: 800px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`
const StepHeaderText = styled('div')`
  font-weight: bold;
  font-size: 18px;
  @media screen and (max-width: 800px) {
    font-size: 16px;
    width: 100%;
    margin: 0 40px 0 0;
  }
`
const StepHeaderButton = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 100px;
  height: 35px;
  position: absolute;
  right: 60px;
  cursor: pointer;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  top: 50%;
  transform: translateY(-50%);
  @media screen and (max-width: 1023px) {
    right: 0;
  }
  @media screen and (max-width: 800px) {
    right: 0;
  }
`;
const StepHeaderButtonPrev = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 60px;
  cursor: pointer;
  display: flex;
  top: 50%;
  transform: translateY(-50%);
  @media screen and (max-width: 1023px) {
    left: 0;
  }
  @media screen and (max-width: 800px) {
    left: 0;
  }
`;
const StepHeaderButtonText = styled('p')`
  margin: 5px 0;
  color: #fff;
`
const SvgWrapper = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(-90deg);
`;
const SvgWrapperReverse = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(90deg);
`;
const CharpstarWrapper = styled('div')`
  width: 100%;
  height: 500px;
  margin: 0 0 2rem;
  background: #f5f5f5;
  @media screen and (max-width: 800px) {
    margin: 0 0 1rem;
    height: 45vh;
  }
`
const CharpstarContainer = styled('div')`
  width: 100%;
  position: relative;
  max-width: 1280px;
  padding: 0 60px;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }
  @media screen and (max-width: 800px) {
    height: 45vh;
  }
`
const LegWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
  max-width: 1280px;
  width: 100%;
  padding: 0 60px;
  margin: 0 auto;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }
`
const ProductInfo = styled('div')`
  position: absolute;
  top: 20px;
  left: 60px;
  z-index: 10;
  text-align: left;
  @media screen and (max-width: 1023px) {
    left: 20px;
  }
`
const ProductName = styled('p')`
  margin: 0;
  font-weight: 700;
`

export const LegStep = ({ currentStep, setCurrentStep, activeProduct, setActiveProduct, activeCategory, setActiveCategory, activeTextileIndex, setActiveTextileIndex, activeLeg, setActiveLeg }) => {
  const [isCharpstarLoaded, setIsCharpstarLoaded] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [legs, setLegs] = useState(() => {
    // Try to load from sessionStorage on first render
    try {
      const stored = sessionStorage.getItem('mobelmastarna_3d_legs');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const [textiles, setTextiles] = useState(() => {
    // Try to load from sessionStorage on first render
    try {
      const stored = sessionStorage.getItem('mobelmastarna_3d_textiles');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const [defaultArticleNumberForVariant, setDefaultArticleNumberForVariant] = useState(null);
  const [availableVariants, setAvailableVariants] = useState([]);
  const [productPrice, setProductPrice] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [selectedArticleNumber, setSelectedArticleNumber] = useState(null);
  const [charpstARConfig, setCharpstARConfig] = useState(null);

  const legData = activeProduct.legs;
  let productDatasTmp = legData.reduce((acc, legItem) => {
    if (legItem.useDifferentArticle) {
      acc[legItem.useDifferentArticle] = getProduct(
        legItem.useDifferentArticle
      );
    }
    return acc;
  }, { [activeProduct.defaultArticleNumber]: activeProduct.productData });
  
  const productDatas = useMemo(() => {
    return { ...productDatasTmp }
  }, [productDatasTmp])

  useEffect(() => {
    (async () => {
      try {
        // Note: This only works if the script is an ES module AND your bundler allows it!
        const module = await import(/* webpackIgnore: true */ 'https://js.charpstar.net/MobelMastarna/charpstAR-MobelMastarna-v2.js');
        setCharpstARConfig(module.default);
        // Use module exports here
      } catch (error) {
        console.error('Failed to load module:', error);
      }
    })();
  }, [charpstARConfig]);
  useEffect(() => {
    if (currentStep === 4 && window.sessionStorage.getItem('lastStep')) {
      const lastStep = Number(window.sessionStorage.getItem('lastStep'));
      if (lastStep < 3) {
        sessionStorage.removeItem('mobelmastarna_3d_legs');
      }
    }
  }, [currentStep]);
  useEffect(() => {
    if (charpstARConfig === null) return;
    if (typeof charpstARConfig === 'undefined') {
      console.error('charpstARConfig is not defined');
      return;
    }
    charpstARConfig
      .init()
      .then(() => {
        const intervalId = setInterval(() => {
          if (charpstARConfig.viewerElement !== null) {
            charpstARConfig.viewerElement.style.opacity = 0;
            clearInterval(intervalId);
            setIsCharpstarLoaded(true);
            charpstARConfig.setFabricMaterial(textiles[activeTextileIndex].name);
          }
        }, 10);
      })
      .catch((error) => {
        console.error('charpstARConfig initialization failed:', error);
      });
  }, [activeTextileIndex, charpstARConfig, textiles]);
  useEffect(() => {
    if (!isCharpstarLoaded || !activeProduct || legs.length > 0) return;
    const legMaterials = charpstARConfig.getAvailableLegMaterials();
    if (Array.isArray(legMaterials) && legMaterials.length > 0) {
      const legData = activeProduct.legs
      let legsArr = [];
      legMaterials.forEach((leg, index) => {
        if (legData && legData.length) {
          legData.forEach((legItem, legIndex) => {
            if (legItem.name.toLowerCase() === leg.toLowerCase()) {
              legsArr.push({
                id: index,
                name: leg,
                publicName: legItem.publicName ? legItem.publicName : leg,
                useDifferentArticle: legItem.useDifferentArticle ? legItem.useDifferentArticle : false,
              });
            }
          })
        } else {
          legsArr.push({
            id: index,
            name: leg,
            publicName: leg,
            useDifferentArticle: false
          })
        }
      })
      setLegs(legsArr);
      sessionStorage.setItem('mobelmastarna_3d_legs', JSON.stringify(legsArr));
      if (activeLeg === null) {
        setActiveLeg(0);
        setActiveIndex(0);
        charpstARConfig.setLegMaterial(legsArr[0].name);
      } else {
        if (legsArr[activeLeg].name) {
          charpstARConfig.setLegMaterial(legsArr[activeLeg].name);
          setActiveIndex(activeLeg);
          setActiveLeg(activeLeg);
        }
      }
    }
  }, [isCharpstarLoaded, legs.length, activeLeg, setActiveLeg, activeProduct, charpstARConfig]);
  useEffect(() => {
    if (!isCharpstarLoaded) return;
    charpstARConfig.viewerElement.style.opacity = 1;
    if (activeLeg === null || !legs[activeLeg]) { return };
    charpstARConfig.setLegMaterial(legs[activeLeg].name);
    if (activeIndex !== activeLeg) setActiveIndex(activeLeg);
    charpstARConfig.setViewToLeg();
  }, [isCharpstarLoaded, activeLeg, setActiveLeg, legs, productDatas, activeIndex, charpstARConfig]);
  useEffect(() => {
    if (!activeProduct) return;
    if (!legs.length) return;
    if (activeLeg === null) return
    if (Object.values(productDatas).every(v => v == null)) return;

    let productData = activeProduct.productData
    if (legs[activeLeg].useDifferentArticle) {
      productData =  productDatas[legs[activeLeg].useDifferentArticle]
    }

    if (!productData?.variants) return;
    
    const tmpAvailableVariants = productData.variants.values
      .filter((variant) => activeProduct.articleNumbers.includes(variant.articleNumber))
      .map((variant) => variant.articleNumber);

    if (tmpAvailableVariants.length > 0 && JSON.stringify(tmpAvailableVariants) !== JSON.stringify(availableVariants)) {
      setAvailableVariants(tmpAvailableVariants);
    }
    setDefaultArticleNumberForVariant(activeProduct.articleNumbers[0]);
  }, [activeLeg, activeProduct, availableVariants, legs, productDatas]);

  useEffect(() => {
    if (activeTextileIndex === null) return
    if (!textiles[activeTextileIndex]) return
    if (!activeProduct) return;
    if (!activeProduct.productData) return;
    if (!activeProduct.selectedVariant) return;
    if (!availableVariants.length) return;
    if (!legs.length) return;
    if (activeLeg === null) return
    if (!legs[activeLeg]) return;
    if (Object.values(productDatas).every(v => v == null)) return

    let productData = activeProduct.productData
    if (legs[activeLeg].useDifferentArticle) {
      productData = productDatas[legs[activeLeg].useDifferentArticle]
    } else {
      productData = productDatas[activeProduct.defaultArticleNumber]
    }

    if (!productData.variants) return;

    const textileName = textiles[activeTextileIndex]?.name?.toLowerCase().trim();
    const configMatch = VariantTextileMapConfig.filter(
      (item) => item.prefix.toLowerCase().trim() === textileName
    );

    const variantArticleNumbers = productData?.variants?.values?.map(
      (variant) => variant.articleNumber
    ) || [];

    const matchingArticleNumbers = configMatch
      .map((item) => item.articleNumber)
      .filter((articleNumber) => variantArticleNumbers.includes(articleNumber));

    let selectedVariant = matchingArticleNumbers[0];
    // eslint-disable-next-line array-callback-return
    matchingArticleNumbers.map((matchingArticleNumber, index) => {
      if (availableVariants.includes(matchingArticleNumber)) {
        selectedVariant = matchingArticleNumber
      }
    })

    const selectedVariantObj = productData?.variants?.values?.find(
      (variant) => variant.articleNumber === selectedVariant
    );

    const selectedArticleNmbr = selectedVariantObj?.articleNumber
    if (selectedArticleNmbr !== selectedArticleNumber) {
      setSelectedArticleNumber(selectedArticleNmbr)
    }
    const incVatPrice = selectedVariantObj?.price?.incVat;
    setProductPrice(incVatPrice)
    const previousPrice = selectedVariantObj?.previousPrice?.incVat ? selectedVariantObj.previousPrice.incVat : 0;
    let pricePrevious = '0,00'
    let discountPrice = '0,00'
    let price = '0,00'
    setProductPrice('0,00')
    if (previousPrice && incVatPrice !== selectedVariantObj?.previousPrice.incVat) {
      discountPrice = selectedVariantObj?.price.incVat
      pricePrevious = selectedVariantObj?.previousPrice.incVat
    } else {
      price = incVatPrice
    }
    if (discountPrice && discountPrice !== '0,00') {
      setDiscount(discountPrice.toString().replace('.', ','));
      if (pricePrevious) {
        setProductPrice(pricePrevious.toString().replace('.', ','));
      }
    } else {
      if (price) {
        setProductPrice(price.toString().replace('.', ','));
      }
    }

  }, [activeProduct.productData.variants.values, activeTextileIndex, textiles, productPrice, availableVariants, activeProduct, legs, activeLeg, productDatas, selectedArticleNumber, activeIndex]);

  // Render loading until client-only data is ready
  if (!activeProduct || !defaultArticleNumberForVariant || !availableVariants.length || !legs.length || productPrice === null  ||
    Object.values(productDatas).every(v => v == null) || !textiles.length) {
    return (
      <>
        <StyledWrapperStepFive id="3d-wrapper">
          <CharpstarWrapper>
            <CharpstarContainer>
              <ProductInfo>
                <ProductName>{activeProduct.name}</ProductName>
                <ProductPrice>Pris: {productPrice}:-</ProductPrice>
              </ProductInfo>
              {
                <charpstar-container data-product={activeProduct.articleNumbers[0]}></charpstar-container>
              }
            </CharpstarContainer>
          </CharpstarWrapper>
          <StepHeader>
            <div style={{position: 'relative'}}>
              <StepHeaderButtonPrev active={1} onClick={() => {
                setCurrentStep(i => i - 1)
                setActiveTextileIndex(activeTextileIndex)
                setActiveLeg(activeLeg)
                window.sessionStorage.setItem('lastStep', currentStep - 1);
              }}>
                <SvgWrapperReverse>
                  <Carrot />
                </SvgWrapperReverse>
              </StepHeaderButtonPrev>
            </div>
            <StepHeaderText>{t('Ben')}<StepHeaderTextDescription>4/5</StepHeaderTextDescription></StepHeaderText>
            <div style={{position: 'relative'}}>
              <StepHeaderButton active={1} onClick={() => {
                setCurrentStep(i => i + 1)
                window.sessionStorage.setItem('lastStep', currentStep);
              }}>
                <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
                <SvgWrapper>
                  <Carrot />
                </SvgWrapper>
              </StepHeaderButton>
            </div>
          </StepHeader>
        </StyledWrapperStepFive>
      </>
    )
  }

  return (
    <>
      <StyledWrapperStepFive id="3d-wrapper">
        <CharpstarWrapper>
          <CharpstarContainer>
            <ProductInfo>
              <ProductName>{legs[activeLeg].useDifferentArticle ? productDatas[legs[activeLeg].useDifferentArticle].name : productDatas[activeProduct.defaultArticleNumber].name}</ProductName>
              <ProductPrice price={productPrice} discount={discount} />
            </ProductInfo>
            {
              <charpstar-container data-product={activeProduct.articleNumbers[0]}></charpstar-container>
            }
          </CharpstarContainer>
        </CharpstarWrapper>
        <StepHeader>
          <div style={{position: 'relative'}}>
            <StepHeaderButtonPrev active={1} onClick={() => {
              setCurrentStep(i => i - 1)
              setActiveTextileIndex(activeTextileIndex)
              setActiveLeg(activeLeg)
              window.sessionStorage.setItem('lastStep', currentStep - 1);
            }}>
              <SvgWrapperReverse>
                <Carrot />
              </SvgWrapperReverse>
            </StepHeaderButtonPrev>
          </div>
          <StepHeaderText>{t('Ben')}<StepHeaderTextDescription>4/5</StepHeaderTextDescription></StepHeaderText>
          <div style={{position: 'relative'}}>
            <StepHeaderButton active={1} onClick={() => {
              let updatedProduct = { ...activeProduct, selectedVariant: selectedArticleNumber}
              updatedProduct = { ...updatedProduct, productData: legs[activeLeg].useDifferentArticle ? productDatas[legs[activeLeg].useDifferentArticle] : productDatas[activeProduct.defaultArticleNumber] };
              setActiveProduct(updatedProduct);
              setCurrentStep(i => i + 1)
              window.sessionStorage.setItem('lastStep', currentStep);
            }}>
              <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
              <SvgWrapper>
                <Carrot />
              </SvgWrapper>
            </StepHeaderButton>
          </div>
        </StepHeader>
        {legs.length ?
          <LegWrapper>
            {legs.map((leg, index) => (
              <Leg3D
                key={index}
                leg={leg}
                active={activeIndex === index}
                onClick={() => {if (activeIndex !== index) {
                  setActiveLeg(index)
                  setActiveIndex(index)
                }
                }}
              />
            ))}
          </LegWrapper>
          : <div>Loading...</div>}
      </StyledWrapperStepFive>
    </>
  )
}